import React, {useState} from 'react';

import {
  Container,
  FooterPromoButton,
  FooterPromoButtonText,
  FooterPromoRow,
  FooterPromoTitle,
  FooterPromoTitleHighlight,
  FooterPromoWrapper,

  TrustBadgesRow,
  TrustBadgeItem,
  TrustBadgeDivider,
  SenatranBadge,
  SenatranSelo,
  SenatranTextWrapper,
  SenatranLabel,
  SenatranTitle,
  TrustBadgePciImage,
} from './styles';
import { Platform} from 'react-native';
import {Button} from '../../../../../Interface/Forms/Buttons/Button';
import {FinesStepsModal} from './FinesStepsModal';

const seloImage = require('../../../../../../assets/images/selo.webp');
const pciDssImage = require('../../../../../../assets/images/Certification-PCI-DSS.png');

type Props = {
  title: string;
  enabled: boolean;
  loading?: boolean;
  onPayButtonPress: () => void | Promise<void>;
  showReferAndWinButton?: boolean;
  tipoOperacao?: string | null;
  productName?: string | null;
};

export function CheckoutFooter({title, enabled, loading, onPayButtonPress, showReferAndWinButton = true, tipoOperacao}: Props) {
  const [showFinesModal, setShowFinesModal] = useState(false);

  if (tipoOperacao === 'debito_veicular') {
    return (
      <Container>
        <TrustBadgesRow>
          <TrustBadgeItem>
            <SenatranBadge>
              <SenatranSelo source={seloImage} resizeMode="contain" />
              <SenatranTextWrapper>
                <SenatranLabel>Somos credenciados pelo</SenatranLabel>
                <SenatranTitle>SENATRAN</SenatranTitle>
              </SenatranTextWrapper>
            </SenatranBadge>
          </TrustBadgeItem>

          <TrustBadgeDivider />

          <TrustBadgeItem>
            <TrustBadgePciImage source={pciDssImage} resizeMode="contain" />
            <SenatranLabel style={{textAlign: 'center', marginTop: 2}}>Certificado de Segurança Internacional</SenatranLabel>
          </TrustBadgeItem>
        </TrustBadgesRow>

        <Button title={title} enabled={enabled} loading={loading} onPress={onPayButtonPress} />
      </Container>
    );
  }

  return (
    <>
      <Container>
        {showReferAndWinButton && Platform.OS !== 'web' && (
          <FooterPromoWrapper>
            <FooterPromoRow>
              <FooterPromoTitle>
                Parcele suas{' '}
                <FooterPromoTitleHighlight>
                  multas e IPVA!
                </FooterPromoTitleHighlight>
              </FooterPromoTitle>
              <FooterPromoButton
                activeOpacity={1}
                onPress={() => setShowFinesModal(true)}>
                <FooterPromoButtonText>Saiba mais</FooterPromoButtonText>
              </FooterPromoButton>
            </FooterPromoRow>
          </FooterPromoWrapper>
        )}

        <Button title={title} enabled={enabled} loading={loading} onPress={onPayButtonPress} />
      </Container>

      {showReferAndWinButton && <FinesStepsModal
        isOpen={showFinesModal}
        onClose={() => setShowFinesModal(false)}
      />}
    </>
  );
}
